import initialState from "./initialState";

export const types = {
  reset: "reset",
  INITIALIZE_EDITOR: "INITIALIZE_EDITOR",
  INITIALIZE_VIEWER: "INITIALIZE_VIEWER",
  INITIALIZE_PUBLIC_VIEW: "INITIALIZE_PUBLIC_VIEWER",
  SET_META_DATA: "SET_META_DATA",
  TOGGLE_FILTER_MANAGER: "TOGGLE_FILTER_MANAGER",
  SET_ACTIVE_GRID_LEVEL: "SET_ACTIVE_GRID_LEVEL",
};

export default {
  /**
   * Initializes studio for editable views
   */
  [types.INITIALIZE_EDITOR]: state => {
    state.isFiltersEditable = true;
    state.isLayersEditable = true;
    state.isConfigsEditable = true;
    state.isInitialized = true;
    state.isTempWidgets = true;
    state.isPublicView = false;
  },

  /**
   * Initializes the studio for viewing mode
   */
  [types.INITIALIZE_VIEWER]: state => {
    state.isFiltersEditable = false;
    state.isLayersEditable = false;
    state.isConfigsEditable = false;
    state.isInitialized = true;
    state.isTempWidgets = false;
    state.isPublicView = false;
  },

  /**
   * Initializes the studio for public view mode
   */

  [types.INITIALIZE_PUBLIC_VIEW]: state => {
    state.isFiltersEditable = false;
    state.isLayersEditable = false;
    state.isConfigsEditable = false;
    state.isTempWidgets = false;
    state.isPublicView = true;
    state.isInitialized = true;
  },
  /**
   * Sets the metadata of the studio
   */
  [types.SET_META_DATA]: (state, meta) => {
    state.id = meta.id;
    state.name = meta.name;
    state.description = meta.description;
    state.city = meta.city;
    state.created_by = meta.created_by;
  },

  /**
   * toggles filter manager
   */
  [types.TOGGLE_FILTER_MANAGER]: state => {
    state.isFiltersVisible = !state.isFiltersVisible;
  },

  /**
   * Set's the active grid level of the console
   */
  [types.SET_ACTIVE_GRID_LEVEL]: (state, data) => {
    state.activeGridLevel = data;
  },

  /**
   * Resets the studio with it's initial state
   */
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },
};
